import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Planning/imprimirPlanning`, method: 'POST', body: values, token: token})
}